import { Player } from './Player';
import { Suit } from '../playing-cards';

export class RoundData {
    players: Player[];
    score: number;
    suit: Suit;
    winner?: number;

    constructor (players: Player[], suit: Suit, score: number = 0, winner?: number) {
        this.suit = suit;
        this.players = JSON.parse(JSON.stringify(players));
        this.score = score || 0;
        this.winner = winner;
    }
}


export function getTeamPlayers (players: Player[], teamIndex: number): Player[] {
    return players.filter((_, i) => i === (teamIndex) || i === (teamIndex + 2));
}

export function getTeamScore (rounds: RoundData[], teamIndex: number) {
    return rounds.reduce((acc, round) => {
        if (round.winner === teamIndex) {
            acc += round.score;
        }
        return acc;
    }, 0);
}


// WEBPACK FOOTER //
// ./src/engine/RoundData.ts